import React from "react";
import BlueTick from "../../../assets/svg/icons/common/blue-tick";
import GrayCross from "../../../assets/svg/icons/common/gray-cross";
import styles from "./styles.module.scss";

const Switch = ({ id, name, label, value, ...props }) => {
  const handleLabelClick = () => {
    const input = document.getElementById(id);
    if (input) {
      input.click();
    }
  };

  return (
    <div className={styles.switchContainer}>
      <label htmlFor={id}></label>
      <div className={styles.switch}>
        <input id={id} type="checkbox" name={name} value={value} {...props} />
        <div className={styles.circle}>
          <span className={styles.checkedState}>
            <BlueTick />
          </span>
          <span className={styles.uncheckedState}>
            <GrayCross />
          </span>
        </div>
      </div>
      {label && (
        <span 
          className={styles.switchText} 
          onClick={handleLabelClick}
          style={{ cursor: 'pointer' }}
        >
          {label}
        </span>
      )}
    </div>
  );
};

export default Switch;
